import { ChevronRight, Home } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const routeLabels: Record<string, string> = {
  '': 'Dashboard',
  users: 'Utilisateurs',
  organisations: 'Organisations',
  domains: 'Domaines',
  automations: 'Automatisations',
  executions: 'Exécutions',
  queues: 'Files d\'attente',
  vaults: 'Coffres-forts',
  billing: 'Facturation',
  invoices: 'Factures',
  pricing: 'Tarification',
  revenue: 'Revenus',
  communications: 'Communications',
  incidents: 'Incidents',
  maintenance: 'Maintenance',
  announcements: 'Annonces',
  emails: 'Campagnes email',
  monitoring: 'Monitoring',
  logs: 'Logs',
  'browser-pool': 'Browser Pool',
  settings: 'Configuration',
  'audit-log': 'Journal d\'audit',
  profile: 'Profil',
};

export function Breadcrumbs() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  if (segments.length === 0) return null;

  return (
    <nav className="flex items-center gap-1.5 text-sm text-neutral-500">
      <Link to="/" className="flex items-center gap-1 transition-all duration-200 hover:text-neutral-300">
        <Home className="h-3.5 w-3.5" />
      </Link>
      {segments.map((segment, index) => {
        const path = '/' + segments.slice(0, index + 1).join('/');
        const isLast = index === segments.length - 1;
        const label = routeLabels[segment] || segment;

        return (
          <span key={path} className="flex items-center gap-1.5">
            <ChevronRight className="h-3.5 w-3.5 text-neutral-600" />
            {isLast ? (
              <span className="font-medium text-neutral-200">{label}</span>
            ) : (
              <Link to={path} className="transition-all duration-200 hover:text-neutral-300">
                {label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
